// extracted by extract-css-chunks-webpack-plugin
module.exports = {"checkoutCatridge":"slw-8","cartIdFeedbackCTAContainer":"gaLcO","blockWithCart":"Jwz0t","cartArticleBlock":"xyWMD"};